import Alert from 'common/components/alert/Alert';
import AlertType from 'common/types/AlertType';
import { useEffect } from 'react';

interface Props {
  result: boolean | null;
  messageSuccess: string;
  messageFailure: string;
  onClose: () => void;
}

const MessageResult: React.FC<Props> = ({
  result,
  messageSuccess,
  messageFailure,
  onClose,
}) => {
  useEffect(() => {
    if (result) {
      const timeoutId = setTimeout(() => {
        onClose();
      }, 3000);

      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [result, onClose]);

  if (result === null) return null;

  return (
    <>
      {result && <Alert type={AlertType.success}>{messageSuccess}</Alert>}
      {result === false && (
        <Alert type={AlertType.danger}>{messageFailure}</Alert>
      )}
    </>
  );
};

export default MessageResult;
